import { headers } from "jsreport-browser-client-dist";
import {
  deleteData,
  getData,
  postData,
  putData,
  putDataWithoutAuth,
} from "./APIServiceInterface";
import axios from "axios";

const token = localStorage.getItem("msal.idtoken");

export const getDrawingService = (modelId) => {
  return getData(`maintenance/drawing/get?modelId=${modelId}`);
};

export const getPreSignedUrl = (modelId, file) => {
  return getData(
    `maintenance/preSignedUrl/get?filename=${file}&modelId=${modelId}`
  );
};

export const getMultipleSignedUrl = (payload) => {
  return axios({
    method: "POST",
    url: `maintenance/GetPreSignedUrls`,
    data: payload,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getS3BucketLayers = (modelId, file) => {
  return getData(
    `maintenance/s3BucketLayers/get?filename=${file}&modelId=${modelId}`
  );
};

export const createNewDrawing = (payload) => {
  return putData("maintenance/drawing/create", payload);
};

export const uploadNewDrawingToS3 = (preSignedUrl, payload) => {
  return putDataWithoutAuth(preSignedUrl, payload);
};

export const saveDrawing = (payload) => {
  return postData("maintenance/drawing/update", payload);
};

export const deleteDrawingService = (payload) => {
  return deleteData("maintenance/drawing/delete", payload);
};

export const getUploadedDrawings = (modelId) => {
  return getData(
    `maintenance/GetS3filesInfo?modelId=${modelId}&isMapping=false`
  );
};
